'use client'; // Error components must be Client Components

import { LocalizationProvider, withThemeProvider } from '@capsicum/common';
import { type Environment } from '@socios/translations';
import { type PropsWithChildren, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';

import { env } from '../../../util/env';

export function GenericErrorWrapper({ children }: PropsWithChildren) {
	const ThemeWrapper = useMemo(() => withThemeProvider(ThemeProvider), []);

	return (
		<ThemeWrapper>
			<LocalizationProvider environment={env.NEXT_PUBLIC_ENV! as Environment}>{children}</LocalizationProvider>
		</ThemeWrapper>
	);
}
